import React from 'react'
import { Chip } from '@mui/material'
import { CheckCircleRounded, CancelRounded, WarningAmberRounded } from '@mui/icons-material'
import { statusTypeLabel } from '../constants'
import styles from './styles.module.css'

/** Mirrors ListProduct getStatusDisplay colors/icons for a filled status chip (local sx only). */
const getStatusChipAppearance = (status_type) => {
  if (!status_type) {
    return { bg: '#e65100', fg: '#ffffff', Icon: WarningAmberRounded }
  }
  const normalized = String(status_type).toLowerCase()
  if (normalized === 'approved') {
    return { bg: '#2e7d32', fg: '#ffffff', Icon: CheckCircleRounded }
  }
  if (normalized === 'rejected' || normalized === 'reject' || normalized.includes('reject')) {
    return { bg: '#e53935', fg: '#ffffff', Icon: CancelRounded }
  }
  if (normalized.includes('pending') || normalized.includes('review')) {
    return { bg: '#e65100', fg: '#ffffff', Icon: WarningAmberRounded }
  }
  return { bg: '#e65100', fg: '#ffffff', Icon: WarningAmberRounded }
}

export const FormHeader = ({ product, productType, changedCount, onClose }) => {
  const statusType = product?.status_type
  const statusNote = product?.status_notes
  const normalizedStatus = statusType ? String(statusType).toLowerCase() : ''
  const showRejectNote = Boolean(statusNote) && normalizedStatus.includes('reject')

  const chipAppearance = statusType ? getStatusChipAppearance(statusType) : null
  const ChipIcon = chipAppearance?.Icon

  return (
    <div className={styles.header}>
      <div className={styles.headerTop}>
        <div className={styles.headerLeft}>
          <div className={styles.headerTitle}>Edit Product</div>
          <div className={styles.headerSubtitle}>
            SKU:{' '}
            <span className={styles.skuSpan}>{product?.product_sku}</span>
            {' · '}
            <span className={styles.menuTypeSpan}>
              {productType === 'non_meal_item' ? 'Regular Menu' : 'Combo Menu'}
            </span>
          </div>

          {changedCount > 0 && (
            <div className={styles.changedBadge}>
              <span className={styles.badgeDot}>●</span>
              {changedCount} field{changedCount > 1 ? 's' : ''} modified
            </div>
          )}
        </div>

        <button onClick={onClose} className={styles.headerCloseBtn}>✕</button>
      </div>

      {statusType && chipAppearance && (
        <div className={styles.statusSection}>
          <div>
            <Chip
              icon={<ChipIcon sx={{ fontSize: 18, color: 'inherit' }} />}
              label={statusTypeLabel[statusType] || statusType}
              size='small'
              sx={{
                backgroundColor: chipAppearance.bg,
                color: chipAppearance.fg,
                border: 'none',
                height: '22px',
                fontSize: '11px',
                fontFamily: 'Inter Medium',
                '& .MuiChip-icon': { color: 'inherit' },
              }}
            />
          </div>
          {showRejectNote && (
            <div className={styles.statusNote}>Note: {statusNote}</div>
          )}
        </div>
      )}
    </div>
  )
}
